interface IReduction {
    /** The amount of products that have to be bought for the reduced price to be active. */
    minAmount: number;
    /** The reduced product price. */
    price: number;
}

export interface IProduct {
    sort: number;
    desc: string;
    id: number;
    new: boolean;
    soldOut?: boolean;
    price: number;
    title: string;
    imgUrl: string;
    /** Information about dynamic price reduction. */
    reduction?: IReduction
}

export class Product implements IProduct {
    public sort: number;
    public desc: string;
    public id: number;
    public new: boolean = false;
    public soldOut: boolean = false;
    public price: number;
    public title: string;
    public imgUrl: string;
    public reduction?: IReduction;

    public constructor(o?: IProduct, imgUrl?: string) {
        if (o !== undefined && o !== null) {
            this.copyFromObject(o);
        }
    }

    public copyFromObject(that: IProduct): void {
        this.sort = that.sort;
        this.desc = that.desc;
        this.id = that.id;
        this.new = that.new;
        this.price = that.price;
        if (that.soldOut !== null) {
            this.soldOut = that.soldOut!;
        }
        this.title = that.title;
        this.imgUrl = that.imgUrl;

        if (that.reduction) {
            this.reduction = that.reduction;
        }
    }
}

// TODO: Once we get products from the backend this isn't needed anymore
import mslBlack from "../../images/products/msl_black_4-3.jpg";
import mslDouble from "../../images/products/msl_double_4-3.jpg";
import mslSingle from "../../images/products/msl_single_4-3.jpg";
import mslWhite from "../../images/products/msl_white_4-3.jpg";
import mslTactical from "../../images/products/msl_tactical_4-3.jpg";
import mslTacticalPlus from "../../images/products/msl_tactical_plus_4-3.jpg";

export const ALL_PRODUCTS = [
    new Product({ sort: 0, id: 0, title: "MSL Sport Schwarz", desc: "MSL Sport Schnelllader in schwarz", price: 29.90, imgUrl: mslBlack, new: false, soldOut: true }),
    new Product({ sort: 1, id: 1, title: "MSL Sport Weiß", desc: "MSL Sport Schnelllader in weiß", price: 29.90, imgUrl: mslWhite, new: false, soldOut: true }),
    new Product({ sort: 5, id: 2, title: "Cliphalter Einfach", desc: "Cliphalter für einen MSL (dargestellt in weiß)", price: 5, imgUrl: mslSingle, new: false }),
    new Product({ sort: 6, id: 3, title: "Cliphalter Doppelt", desc: "Cliphalter für zwei MSL (dargestellt in weiß)", price: 10, imgUrl: mslDouble, new: false }),
    new Product({ sort: 3, id: 4, title: "MSL Tactical", desc: "Schnelllader mit extra Haftkraft in schwarz", price: 29.90, imgUrl: mslTactical, new: false, soldOut: true }),
    new Product({ sort: 4, id: 5, title: "MSL Tactical Plus Schwarz", desc: "Schnelllader mit extra Haftkraft und Höhenunterschied für einfacheres Einführen in schwarz", price: 34.90, imgUrl: mslTacticalPlus, new: false, soldOut: true }),
    new Product({ sort: 4, id: 5, title: "MSL Tactical Plus Weiß", desc: "MSL Tactical Plus in weiß (Foto zeigt den MSL Sport weiß)", price: 34.90, imgUrl: mslWhite, new: false, soldOut: true }),
].sort((a, b) => a.sort - b.sort);



// WEBPACK FOOTER //
// ./src/api/models/Product.ts